<div class="loginmodal" id="loginmodal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
  <div>
    <div class="modal-content">
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" #closeBtn (click)="clearRedeirectUrl();hideModel();"><span aria-hidden="true">&times;</span></button>
        <img src="../assets/img/logos/logo-white.png" alt="logo" class="whitelogo" *ngIf="stage!=5">
        <div *ngIf="stage == 1">
          <ul class="nav nav-tabs" role="tablist">
            <!--<li role="presentation" [class.active]="isLoginActive"><a href="#login" aria-controls="login" role="tab" data-toggle="tab" (click)="onLoginOrRegisterClick(false)">Login</a></li>-->
            <li role="presentation" [class.active]="!isLoginActive"><a href="#register" aria-controls="register" role="tab" data-toggle="tab" (click)="onLoginOrRegisterClick(false)">Register</a></li>
          </ul>
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane" id="register" [class.active]="!isLoginActive">
              <section class="margin-section">
                <label class="label">First Name<span class="red">*</span></label>
                <input type="text" class="form-control" name="" #firstNameinput="ngModel" [(ngModel)]="registerModel.firstName" required maxlength="30">
                <p class="redtext" *ngIf="!showFNSpecCharVal && (showValidation && firstNameValid && firstNameinput.invalid && firstNameinput.touched)">First name is required</p>
                <p class="redtext" *ngIf="!showFNSpecCharVal && (!firstNameValid)">First name is required</p>
                <p class="redtext" *ngIf="showFNSpecCharVal">{{specCharValMsg}}</p>
              </section>
              <section class="margin-section">
                <label class="label">Last Name<span class="red">*</span></label>
                <input type="text" class="form-control" name="" #lastNameinput="ngModel" [(ngModel)]="registerModel.lastName" required maxlength="30">
                <p class="redtext" *ngIf="!showLNSpecCharVal &&(showValidation && lastNameValid && lastNameinput.invalid && lastNameinput.touched)">Last name is required</p>
                <p class="redtext" *ngIf="!showLNSpecCharVal &&(!lastNameValid)">Last name is required</p>
                <p class="redtext" *ngIf="showLNSpecCharVal">{{specCharValMsg}}</p>
              </section>
              <section class="margin-section">
                <label class="label">Role<span class="red">*</span></label>
                <label class="select">
                  <select class="form-control" #Role="ngModel" (change)="RoleChange();" [(ngModel)]="registerModel.userrole">
                    <option value="0">--Select--</option>
                    <option *ngFor="let roles of userRoleList" [(ngValue)]="roles.id">{{roles.name}}</option>
                  </select>
                  <i></i>
                </label>
                <p class="redtext" *ngIf="(showValidation && RoleValid && Role.invalid && Role.touched)">Role is required</p>
                <p class="redtext" *ngIf="(!RoleValid)">Role is required</p>
              </section>
              <section class="margin-section" *ngIf="registerModel.userrole == 2">
                <label class="custom-checkbox">
                  <input type="checkbox" name="" (change)="onCheckboxSelect(1)" [(ngModel)]="registerModel.is1031Exchange"> Are you on a 1031  Exchange?
                  <i></i>
                </label>
              </section>
              <section class="margin-section">
                <label class="label">Email<span class="red">*</span></label>
                <input readonly type="text" class="form-control" #emailinput="ngModel" (change)="validateemail()" name="" [(ngModel)]="registerModel.email" required maxlength="100">
                <p class="redtext" *ngIf="showValidation && (emailValid) && emailinput.invalid && emailinput.touched">Email is required</p>
                <p class="redtext" *ngIf="(!emailValid) && emailvalidation ==''">Email is required</p>
                <p class="redtext" *ngIf="(emailvalidation!='' && registerModel.email!='')">{{emailvalidation}}</p>
              </section>
              <!--<section class="margin-section">
                  <label class="label">Password<span class="red">*</span></label>
                  <input type="password" class="form-control" name="" #passwordinput="ngModel" (change)="validatepassword()" [(ngModel)]="registerModel.password" required maxlength="250">
                  <p class="redtext" *ngIf="showValidation && (passwordValid && passwordinput.invalid && passwordinput.touched)">Password is required</p>
                  <p class="redtext" *ngIf="(!passwordValid)&& passwordValidation==''">Password is required</p>
                  <p class="redtext" *ngIf="(passwordValidation!='' && registerModel.password!='')">{{passwordValidation}}</p>
              </section>
              <section class="margin-section">
                  <label class="label">Confirm Password<span class="red">*</span></label>
                  <input type="password" class="form-control" #confirmpasswordinput="ngModel" name="confirm" [(ngModel)]="registerModel.confirmpassword" required maxlength="250">
                  <p class="redtext" *ngIf="showValidation && (confirmpasswordValid && confirmpasswordinput.invalid && confirmpasswordinput.touched)">Confirm password is required</p>
                  <p class="redtext" *ngIf="(!confirmpasswordValid)">Confirm password is required</p>
              </section>-->
              <section class="margin-section">
                <label class="label">Phone Number<span class="red">*</span></label>
                <input type="text" class="form-control" #phoneNumberinput="ngModel" (change)="validatePhoneNumber()" name="" mask='(000) 000-0000' [(ngModel)]="registerModel.phoneNumber" required maxlength="20">
                <p class="redtext" *ngIf="showValidation && (phoneValid) && phoneNumberinput.invalid && phoneNumberinput.touched">Phone number is required</p>
                <p class="redtext" *ngIf="(!phoneValid)">Phone number is required</p>
                <p class="redtext" *ngIf="phoneValidation!=''">{{phoneValidation}}</p>
              </section>
              <section class="margin-section">
                <label class="label">Company Name</label>
                <input type="text" class="form-control" name="" [(ngModel)]="registerModel.companyName" maxlength="200" />
              </section>
              <section class="margin-section">
                <label class="custom-checkbox">
                  <input type="checkbox" name="" [(ngModel)]="registerModel.termsAndConditions" id="chkTermsandConditions"> &nbsp;
                  <i></i>
                </label>
                <!--<a href="#" class="checkbox-link">I Agree to Terms and Conditions </a>-->
                <a href="{{Validation.WPSiteUrl}}terms-and-conditions" target="_blank" class="checkbox-link">I Agree to Terms and Conditions</a>

              </section>
              <section class="margin-section">
                <label class="custom-checkbox" style="font-size: 15px; font-weight:600">
                  <input type="checkbox" name="" [(ngModel)]="registerModel.Subscribe" id="chkEmailSubsciption">Subscribe to Our Email Updates
                  <i></i>
                </label>
              </section>
              <section class="margin-section" *ngIf="registerFailedMessage != ''">
                <label class="label" [class]="classToBind">
                  {{registerFailedMessage}}
                </label>
              </section>
              <section class="margin-section">
                <a href="javascript:void(0);" id="Register" (click)="onRegisterClick()" class="loginbtn">Register</a>
              </section>
            </div>
          </div>
        </div>
        <div *ngIf="stage == 2">
          <ul class="nav nav-tabs " role="tablist">
            <li role="presentation" class="active"><a href="#login" aria-controls="login" role="tab" data-toggle="tab">Forgot password ?</a></li>
          </ul>
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane active" id="login">
              <section class="margin-section">
                <label class="label">Enter your registered Email ID<span class="red">*</span></label>
                <input type="text" (keydown)="emailFailMessageHide()" class="form-control" name="" [(ngModel)]="forgotPasswordModel.Email">
              </section>
              <section class="margin-section" *ngIf="checkEmailFailedMessage != ''">
                <label class="label redtext">
                  {{checkEmailFailedMessage}}
                </label>
              </section>
              <section class="margin-section">
                <a href="javascript:void(0);" class="loginbtn" (click)="onCheckEmailClick()">Send</a>
              </section>
              <section class="margin-section forgotpassword">
                <a href="javascript:void(0);" (click)="changeModal(1)">Log In</a>
              </section>
            </div>
          </div>
        </div>
        <div *ngIf="stage == 3">
          <ul class="nav nav-tabs " role="tablist">
            <li role="presentation" class="active"><a href="#login" aria-controls="login" role="tab" data-toggle="tab">Confirmation Code</a></li>
          </ul>
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane active" id="login">
              <section class="margin-section">
                <label class="label wrap-text">A message has been sent to your email address with instructions to reset the password</label>
              </section>
              <section class="margin-section">
                <label class="label">Confirmation Code<span class="red">*</span></label>
                <input type="text" class="form-control" name="" [(ngModel)]="forgotPasswordModel.ConfirmationCode">
              </section>
              <section class="margin-section">

                <label class="label redtext">
                  {{checkEmailFailedMessage}}
                </label>
              </section>
              <section class="margin-section">
                <a href="javascript:void(0);" class="loginbtn" (click)="onConfirmationCodeClick()">Confirm</a>
              </section>
              <section class="margin-section forgotpassword">
                <a href="javascript:void(0);" (click)="changeModal(1)">Log In</a>
              </section>
            </div>
          </div>
        </div>
        <div *ngIf="stage == 4">
          <ul class="nav nav-tabs " role="tablist">
            <li role="presentation" class="active"><a href="#login" aria-controls="login" role="tab" data-toggle="tab">Update Password</a></li>
          </ul>
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane active" id="login">
              <section class="margin-section">
                <label class="label">New Password<span class="red">*</span></label>

                <input type="password" class="form-control" name="" #Rpasswordinput="ngModel" (change)="validateForgotPassword()" [(ngModel)]="forgotPasswordModel.ResetPassword" required maxlength="250">
                <p class="redtext" *ngIf="(!forgotPasswordValid && forgotPasswordValidation=='')||(showValidation && (Rpasswordinput && Rpasswordinput.invalid && Rpasswordinput.touched))">Password is required</p>
                <p class="redtext" *ngIf="(forgotPasswordValidation!='' && forgotPasswordModel.ResetPassword!='')">{{forgotPasswordValidation}}</p>
              </section>
              <section class="margin-section">
                <label class="label">Confirm Password<span class="red">*</span></label>
                <input type="password" class="form-control" name="" [(ngModel)]="forgotPasswordModel.ConfirmPassword">
              </section>
              <section class="margin-section">
                <!--*ngIf="loginFailedMessage != ''"-->
                <label class="label redtext">
                  {{checkEmailFailedMessage}}
                </label>
              </section>
              <section class="margin-section">
                <a href="javascript:void(0);" class="loginbtn" (click)="onResetPasswordClick();">Save</a>
              </section>
              <section class="margin-section forgotpassword">
                <a href="javascript:void(0);" (click)="changeModal(1)">Log In</a>
              </section>
            </div>
          </div>
        </div>
        <div *ngIf="stage == 5">
          <ul class="nav nav-tabs " role="tablist">
            <li role="presentation"><a href="#login" aria-controls="login" role="tab" class="otp-heading" data-toggle="tab">Email Verification</a></li>
          </ul>
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane active" id="login">
              <section class="margin-section">
                <section class="margin-section">
                  <label class="label wrap-text otp-description" style="line-height:1.5 !important;">Enter the 6-digit code sent to your email {{email}}</label>
                </section>
                <div class="otp-wrapper">
                  <div class="otp-container">
                    <input type="text"
                           maxlength="1"
                           class="otp-input"
                           *ngFor="let item of otpArray; let i = index"
                           [(ngModel)]="otpValues[i]"
                           (input)="moveToNext($event, i)"
                           (keydown)="handleKeydown($event, i)"
                            (paste)="handlePaste($event, i)"
                           #otpBox>
                  </div>
                </div>
              </section>

              <section class="margin-section">
                <a href="javascript:void(0);" class="loginbtn" (click)="onOTPVerficationClick();" [class.disabled]="isDisabled">Verify</a>
              </section>
              <section class="margin-section">
                <label class="label  wrap-text " style="text-align:center !important;">
                  Didn't Receive the code?
                </label>
              </section>
              <section class="margin-section">
                <label class="label  wrap-text" style="text-align:center !important;">
                  <div class="mt-3">
                    <span *ngIf="otpCodeLimit > 0&&IsShowOTPMessage" class="resent-otp-text">Resend Email Verification Code in {{ otpCodeLimit }}s</span>
                    <button type="button" class="btn btn-link resent-otp-text" *ngIf="otpCodeLimit === 0" (click)="shareFirstAuthenticationCode()">Resend Email Verification Code</button>
                  </div>
                </label>
              </section>
            </div>
          </div>
        </div>
        <!--<ul class="socialicons" *ngIf="stage == 1">
            <li><a href="javascript:void(0);" (click)="signInWithFB()"><i class="fa fa-facebook icon" aria-hidden="true"></i></a></li>
            <li><a href="javascript:void(0);" (click)="signInWithLinkedIn()"><i class="fa fa-linkedin icon" aria-hidden="true"></i></a></li>
            <li><a href="javascript:void(0);" (click)="signInWithGoogle()"><i class="fa fa-google-plus icon" aria-hidden="true"></i></a></li>
        </ul>-->
      </div>

    </div>
  </div>
</div>


<ng-template #template>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Reset</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefNew.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure you want to Reset your Password ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefNew.hide()">Cancel</button>
      <a href="#" class="btn btn-lg btn-success" [routerLink]="['/']" (click)="onResetPasswordClick();">Reset</a>
    </div>
  </div>

</ng-template>
